import { getAuthCode } from "./getAuthCode";

export const deleteImage = async (id) => {
  try {
    const url = process.env.REACT_APP_BACKEND_URL + "/deleteImage?id=" + id;
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ auth_code: await getAuthCode() })
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
    return false;
  }
};
